import React from 'react';
import Proptypes from 'prop-types';
import styled from 'styled-components';
import { TagInput, Intent, Tag, Tooltip } from '@blueprintjs/core';
import * as _ from 'lodash';
//*/
import Clearfix from 'components/elements/clearfix';
import { COLOR } from 'config';

const ElementWrapper = styled.div``;

export default class TagInputCustom extends React.Component {
  static propTypes = {
    onChange: Proptypes.func,
    value: Proptypes.any,
    LicenseNumberUsed: Proptypes.any,
  };
  state = {
    values: [],
  };

  handleOnChange = (values) => {
    const newValue = _.replace(values.pop(), /,/g, '');
    const index = _.findIndex(
      [...values, ...this.props.LicenseNumberUsed],
      (str) => {
        return str === newValue;
      }
    );
    if (index < 0) {
      values.push(newValue);
    }
    this.setState({
      values: values,
    });
  };

  handleOnAdd = (value) => {
    const data = [...this.props.LicenseNumberUsed, ...this.state.values]
    const index = _.findIndex(data, (str) => {
      return str === value[0];
    });

    if (index < 0) {
      return true;
    } else {
      return false;
    }
  };

  componentDidUpdate = (propsPrev, statePrev) => {
    if (statePrev.values !== this.state.values) {
      // const data = this.props.LicenseNumberUsed;
      // data.push(...this.state.values);
      if (this.props.onChange)
        this.props.onChange(_.compact(this.state.values));
    }
  };

  componentDidMount = () => {
    this.setState({
      values: this.props.value || [],
    });
  };

  getValues = () => {
    const data = _.map(this.state.values, (obj) => {
      const ix = _.findIndex(this.props.LicenseNumberUsed, (str) => {
        return str === obj;
      });
      if (ix < 0) {
        return obj;
      }
    });
    return _.compact(data);
  };

  render() {
    const getTagProps = (value, index) => {
      const ix = _.findIndex(this.props.LicenseNumberUsed, (str) => {
        return str === value;
      });
      return {
        intent: ix >= 0 ? Intent.SUCCESS : Intent.NONE,
        disabled: true,
      };
    };

    return (
      <ElementWrapper>
        <TagInput
          values={this.state.values}
          tagProps={getTagProps}
          onChange={this.handleOnChange}
          onAdd={this.handleOnAdd}
          separator={true}
        />

        {this.props.LicenseNumberUsed &&
          _.map(this.props.LicenseNumberUsed, (str, index) => {
            return (
              <React.Fragment key={index}>
                <Clearfix height={4} />
                <Tooltip content='Số giấy phép đã sử dụng'>
                  <div style={{ display: 'flex' }}>
                    <Tag intent={Intent.SUCCESS} style={{backgroundColor: COLOR.SUCCESS}}>{str}</Tag>
                    <Clearfix width={4} />
                  </div>
                </Tooltip>
              </React.Fragment>
            );
          })}
      </ElementWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/input-tag/index.js